import { render, staticRenderFns } from "./customers.html?vue&type=template&id=bba3a93c&scoped=true&external"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba3a93c",
  null
  
)

export default component.exports